import React from 'react';
import styles from './PurchaseButton.module.scss';
import {MDBBtn} from 'mdbreact';

interface IPurchaseButtonProps {
  isSubmitting?: boolean;
  submitForm?: any;

  className?: string;
}


const PurchaseButton = (props: IPurchaseButtonProps) => (
  <MDBBtn disabled={props.isSubmitting}
          onClick={props.submitForm}
          block
          className={`purchaseButton ${styles.purchaseFormButton} ${props.className}`.trim()}
  >לרכישה</MDBBtn>
);

PurchaseButton.defaultProps = {
  className: '',
};
export default PurchaseButton;
